<div siqGrid fx-direction="column" fx-layout-align="center center" class="pt-96 pb-32 px-24">
  <span class="siq-text-700 fs-24 white text-center mb-48 px-12 w-60-p">Congratulations! You’re on your way to life-changing sleep.</span>
  <app-success-with-particles />
</div>
